import { DateTime } from 'luxon';

export const getDurationInHoursAndMinutes = (startDate: string, endDate: string) => {
  const diffInMinutes = DateTime.fromISO(endDate)
    .diff(DateTime.fromISO(startDate), 'minutes')
    .as('minutes');

  const totalMinutes = Math.round(diffInMinutes);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.ceil(totalMinutes % 60);

  return `${hours}:${String(minutes).padStart(2, '0')}h`;
};
